<template>
  <ExpandedSideSection
    :loading="!showForm"
    :no-data="false"
    :back-route="`/jobs/${route.params.role_id}`"
    back-label="Back to job"
  >
    <JobForm :role-id="String($route.params.role_id)" :is-edit="true" />
  </ExpandedSideSection>
</template>

<script setup lang="ts">
import JobForm from '@/components/jobs/JobForm.vue'
import { computed, onMounted } from 'vue'
import { useRolesStore } from '@/stores/roles'
import { useRoute } from 'vue-router'
import ExpandedSideSection from '@/components/common/ExpandedSideSection.vue'

const route = useRoute()
const roleStore = useRolesStore()

const showForm = computed(() => {
  const roleId = route.params.role_id as string | undefined
  if (!roleId) return false
  return !!roleStore.selectedRole && roleStore.selectedRole.id === Number(roleId)
})

onMounted(async () => {
  const roleId = route.params.role_id as string | undefined
  if (roleId) {
    try {
      await roleStore.fetchRoleById(roleId)
    } catch (e) {
      // swallow; error state can be handled inside JobForm if needed
    }
  }
})
</script>
